<!--
 * @Author: liuxiaoyan
 * @Date: 2021-10-11 16:30:23
 * @LastEditors: renmanyi
 * @LastEditTime: 2023-11-16 09:46:35
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
-->
<template>
  <div class="container">
    <new-package v-if="isNormalVersion" :isShowBasic="isShowBasic"></new-package>
    <old-package v-else></old-package>
  </div>
</template>
<script>
import newPackage from './newPackage'
import oldPackage from './oldPackage'
const VersionEnum = ['STANDARD', 'ADVANCED', 'ULTIMATE', 'CHAIN'];
export default {
  name: 'renew_packages',
  data() {
    return {
      isNormalVersion: false,
      isShowBasic: false
    }
  },
  methods: {
    judgeVersion() {
      const query = {
        instId: window.getParameterByName('instId')
      }
      axios.post("business/anon/inst/getCurrentSaasBasicType", query).then(res=>{
        const { result } = res;
        this.isShowBasic = result==='BASIC';
        const notNormalVersion = VersionEnum.includes(result);
        this.isNormalVersion= !notNormalVersion
      }).catch(e=>{

      })
    }
  },
  computed: {
  },
  // 判断机构是4.0还是5.0
  created(){
    this.judgeVersion()
  },
  mounted() {
  },
  components: {
    newPackage,
    oldPackage
  }
};
</script>

<style lang="less">
.container {
  height: 100vh;
  overflow: scroll;
  font-family: PingFangSC-Regular, PingFang SC;
  background: #ffffff;

}
</style>



// WEBPACK FOOTER //
// src/module/renew/packages.vue